/*
  Het koopblok voor kleding: kleur en maat als losse keuzes.

  Bij parfum is één rijtje varianten genoeg. Bij kleding niet: twee opties
  betekent een rij per optie, en niet elke combinatie bestaat. Zwart in M kan er
  zijn terwijl wit in M op is, en dat moet de bezoeker zien vóór hij klikt — niet
  erna.

  Wat dit bestand doet:
  - de gekozen kleur en maat vertalen naar een variant, en die in het formulier
    zetten
  - per maat tonen of hij er is, bijna op is, of weg
  - de prijs, de knop en het adres meebewegen

  Zonder JavaScript blijft het formulier werken: er staat een gewone keuzelijst
  met alle varianten in een <noscript>, en die verstuurt hetzelfde veld.
*/
(function () {
  'use strict';

  var script = document.currentScript;

  function tekst(naam, terugval) {
    var v = script ? script.getAttribute(naam) : null;
    return v === null || v === '' ? terugval : v;
  }

  var B = {
    geen: tekst('data-balk-geen', 'Nog geen maat gekozen'),
    geenKnop: tekst('data-balk-geen-knop', 'Maat kiezen'),
    op: tekst('data-balk-op', 'Maat {maat} · uitverkocht'),
    klaar: tekst('data-balk-klaar', 'Maat {maat}'),
    klaarKnop: tekst('data-balk-klaar-knop', 'In winkelwagen')
  };

  function init(wortel) {
    var data = wortel.querySelector('[data-kleding-varianten]');
    var form = wortel.querySelector('[data-kleding-form]');
    if (!data || !form) return;

    var varianten;
    try {
      varianten = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }
    if (!varianten.length) return;

    var idVeld = form.querySelector('[data-kleding-id]');
    var prijs = wortel.querySelector('[data-kleding-prijs]');
    var knop = wortel.querySelector('[data-kleding-add]');
    var knopTekst = wortel.querySelector('[data-kleding-add-label]');
    var knopPrijs = wortel.querySelector('[data-kleding-add-price]');
    var afrekenen = wortel.querySelector('[data-kleding-checkout]');
    var melding = wortel.querySelector('[data-kleding-voorraad]');
    var kleurWaarde = wortel.querySelector('[data-kleding-kleurnaam]');
    var titelKleur = wortel.querySelector('[data-kleding-titelkleur]');

    /*
      De plakkende koopbalk. Hij staat buiten de sectie-wortel, dus we zoeken
      hem in het document -- er is er één per pagina.
    */
    var balk = document.querySelector('[data-kleding-balk]');
    var balkPrijs = document.querySelector('[data-balk-prijs]');
    var balkStaat = document.querySelector('[data-balk-staat]');
    var balkKnop = document.querySelector('[data-balk-knop]');
    var balkMaten = document.querySelector('[data-balk-maten]');
    var teksten = {
      kopen: knop ? knop.getAttribute('data-label-kopen') : '',
      uitverkocht: knop ? knop.getAttribute('data-label-uitverkocht') : '',
      kies: knop ? knop.getAttribute('data-label-kies') : ''
    };

    function gekozen(optie) {
      var veld = wortel.querySelector('[data-kleding-optie="' + optie + '"]:checked');
      return veld ? veld.value : null;
    }

    function zoekVariant(kleur, maat) {
      for (var i = 0; i < varianten.length; i++) {
        var v = varianten[i];
        if ((kleur === null || v.kleur === kleur) && (maat === null || v.maat === maat)) return v;
      }
      return null;
    }

    /*
      Per maat kijken of hij bestaat in de gekozen kleur. Een maat die in geen
      enkele kleur bestaat hoort er niet te staan; een maat die in déze kleur op
      is wel, met "Weg" erbij. Verbergen zou de indruk wekken dat het stuk niet
      in die maat gemaakt wordt.
    */
    function ververcMaten() {
      var kleur = gekozen('kleur');
      var chips = wortel.querySelectorAll('[data-maat-chip]');

      for (var i = 0; i < chips.length; i++) {
        var chip = chips[i];
        var maat = chip.getAttribute('data-maat-chip');
        var v = zoekVariant(kleur, maat);
        var staat = chip.querySelector('[data-maat-staat]');

        var beschikbaar = !!(v && v.beschikbaar);
        chip.classList.toggle('is-op', !beschikbaar);

        var invoer = wortel.querySelector('[data-kleding-optie="maat"][value="' + maat + '"]');
        if (invoer) invoer.setAttribute('data-beschikbaar', beschikbaar ? '1' : '0');

        if (staat) {
          if (!beschikbaar) {
            staat.textContent = staat.getAttribute('data-weg') || '';
            staat.hidden = false;
          } else if (v && v.bijna) {
            staat.textContent = staat.getAttribute('data-bijna') || '';
            staat.hidden = false;
          } else {
            staat.textContent = '';
            staat.hidden = true;
          }
        }
      }
    }

    /* Zie de toelichting in toon(): pas na de eerste ronde mag het beeld mee. */
    var geopend = false;
    var uitAdres = /[?&]variant=/.test(window.location.search);

    /*
      De matenrij in de balk.

      De maten komen uit de echte matenrij hierboven -- dat is de enige
      waarheid over welke maten dit stuk heeft -- en wat er leverbaar is komt
      per kleur uit de variantenlijst. Daarom wordt hij bij elke wijziging
      opnieuw opgebouwd: bij een andere kleur is een andere maat op.
    */
    function vulBalkMaten(kleur, maat) {
      if (!balkMaten) return;

      var velden = wortel.querySelectorAll('[data-kleding-optie="maat"]');
      if (!velden.length) {
        balkMaten.hidden = true;
        return;
      }

      balkMaten.innerHTML = '';

      Array.prototype.forEach.call(velden, function (veld) {
        var chip = wortel.querySelector('[data-maat-chip="' + veld.value + '"]');
        var naam = chip ? chip.querySelector('.kpdp__sizename') : null;

        var knopje = document.createElement('button');
        knopje.type = 'button';
        knopje.className = 'kpdpbalk__maat';
        knopje.textContent = naam ? naam.textContent.trim() : veld.value;
        knopje.setAttribute('data-balk-maat', veld.value);

        var variant = zoekVariant(kleur, veld.value);
        knopje.disabled = !(variant && variant.beschikbaar);
        knopje.classList.toggle('is-actief', veld.value === maat);

        balkMaten.appendChild(knopje);
      });

      balkMaten.hidden = false;
    }

    function toon() {
      ververcMaten();

      var kleur = gekozen('kleur');
      var maat = gekozen('maat');

      /*
        Een product zonder maten -- een sjaal, een riem, of een testproduct --
        mag niet blijven hangen op "Kies een maat". Dan is er niets te kiezen
        en koopt de knop gewoon de enige variant.
      */
      var heeftMaten = !!wortel.querySelector('[data-kleding-optie="maat"]');

      if (kleurWaarde && kleur) kleurWaarde.textContent = kleur;
      if (titelKleur && kleur) titelKleur.textContent = kleur;

      var v;
      if (!heeftMaten) v = zoekVariant(kleur, null);
      else v = maat === null ? null : zoekVariant(kleur, maat);

      if (v && idVeld) idVeld.value = v.id;
      if (prijs && v) prijs.textContent = v.prijs;

      if (melding) {
        var regel = v ? (v.melding || '') : '';
        melding.textContent = regel;
        melding.hidden = regel === '';
      }

      if (knop) {
        var kanKopen = !!(v && v.beschikbaar);
        knop.disabled = !kanKopen;

        if (knopTekst) {
          if (heeftMaten && !maat) knopTekst.textContent = teksten.kies || teksten.kopen;
          else if (kanKopen) knopTekst.textContent = teksten.kopen;
          else knopTekst.textContent = teksten.uitverkocht;
        }
        if (knopPrijs) {
          var toonPrijs = kanKopen && v;
          knopPrijs.hidden = !toonPrijs;
          if (toonPrijs) knopPrijs.textContent = ' · ' + v.prijs;
        }
      }

      if (afrekenen) afrekenen.hidden = !(v && v.beschikbaar);

      /*
        De balk. Drie standen, en de knop doet in elke stand iets anders --
        dat is de reden dat hij bestaat: op mobiel scrollt niemand terug naar
        boven voor een foutmelding.
      */
      if (balk && balkKnop) {
        var stand = 'klaar';
        if (heeftMaten && !maat) stand = 'geen';
        else if (!v || !v.beschikbaar) stand = 'op';

        var regel = stand === 'geen' ? B.geen : stand === 'op' ? B.op : B.klaar;
        if (balkStaat) {
          balkStaat.textContent = regel.replace('{maat}', maat || '');
          balkStaat.classList.toggle('is-geen', stand === 'geen');
          balkStaat.classList.toggle('is-op', stand === 'op');
        }

        /*
          Uitverkocht: niets te doen. Nog geen maat: de maten staan er direct
          naast, dus ook dan doet de knop nog niets -- hij zegt alleen wat er
          eerst moet gebeuren.
        */
        balkKnop.textContent = stand === 'geen' ? B.geenKnop
          : stand === 'op' ? teksten.uitverkocht : B.klaarKnop;
        balkKnop.disabled = stand === 'op' || stand === 'geen';
        balkKnop.classList.toggle('is-geen', stand === 'geen');
        balkKnop.classList.toggle('is-op', stand === 'op');
        balkKnop.setAttribute('data-stand', stand);

        if (balkPrijs && v) balkPrijs.textContent = v.prijs;

        vulBalkMaten(kleur, maat);
      }

      /*
        De foto van de gekozen kleur. Die hangt in Shopify aan de variant; is er
        geen foto aan gekoppeld, dan blijft het beeld staan.

        Bij het openen van de pagina gebeurt dit niet: dan hoort de bezoeker de
        eerste foto te zien, niet de foto van de variant die toevallig als
        eerste leverbaar is. Staat er een variant in het adres, dan is die keuze
        wel met opzet gemaakt en springt het beeld er wel naartoe.
      */
      if (v && v.beeld && (geopend || uitAdres)) {
        var beeldmini = wortel.querySelector('[data-kleding-mini][data-media="' + v.beeld + '"]');
        if (beeldmini && beeldmini.classList.contains('is-active') === false) {
          toonBeeld(beeldmini);
          haalInBeeld(beeldmini);
        }
      }

      if (v && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {
          /* Oude browser: het adres blijft staan. */
        }
      }
    }

    /*
      De puntjes onder de mobiele galerij. Ze hangen aan de scroll van de rail,
      gedempt met requestAnimationFrame: in ontwikkeling stonden ze vast op het
      eerste beeld, en een positie-indicator die niet meebeweegt is slechter
      dan geen.
    */
    (function puntjes() {
      var rail = wortel.querySelector('.kpdp__thumbs');
      var vak = wortel.querySelector('[data-kleding-punten]');
      if (!rail || !vak) return;

      var items = rail.children.length;
      if (items < 2) return;

      for (var i = 0; i < items; i++) {
        var punt = document.createElement('span');
        punt.className = 'kpdp__punt' + (i === 0 ? ' is-actief' : '');
        vak.appendChild(punt);
      }

      var wacht = false;
      rail.addEventListener('scroll', function () {
        if (wacht) return;
        wacht = true;
        window.requestAnimationFrame(function () {
          wacht = false;
          if (!rail.clientWidth) return;
          var bij = Math.round(rail.scrollLeft / rail.clientWidth);
          for (var i = 0; i < vak.children.length; i++) {
            vak.children[i].classList.toggle('is-actief', i === bij);
          }
        });
      });
    })();

    wortel.addEventListener('change', function (e) {
      if (!e.target || !e.target.hasAttribute('data-kleding-optie')) return;
      toon();
    });

    /* De knop in de balk doet hetzelfde als de echte koopknop. */
    if (balkKnop) {
      balkKnop.addEventListener('click', function () {
        if (balkKnop.getAttribute('data-stand') === 'geen') return;
        if (knop) knop.click();
      });
    }

    /* Kiezen vinkt het echte veld aan; de rest van de pagina volgt vanzelf. */
    if (balkMaten) {
      balkMaten.addEventListener('click', function (e) {
        var knopje = e.target.closest('[data-balk-maat]');
        if (!knopje || knopje.disabled) return;

        var veld = wortel.querySelector('[data-kleding-optie="maat"][value="' + knopje.getAttribute('data-balk-maat') + '"]');
        if (!veld) return;

        veld.checked = true;
        veld.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /*
      Wanneer de balk in beeld komt.

      Pas wanneer de echte koopknop naar boven uit beeld is gescrold. Nadrukkelijk
      niet wanneer de knop nog onder het scherm zit: bovenaan de pagina heeft de
      bezoeker de knop nog voor zich, en dan is een tweede knop over het beeld
      heen alleen maar drukte.

      Meten met de rechthoek van de knop en niet met een IntersectionObserver:
      die hoeft niet opnieuw ingesteld te worden wanneer de knop verspringt
      doordat de maatadviseur opengaat, en het is één regel om na te rekenen.

      Het meten hangt aan de scroll, gedempt met requestAnimationFrame: één
      meting per beeld is genoeg en scheelt werk tijdens het scrollen.
    */
    if (balk && knop) {
      /* Nu JavaScript het overneemt mag hij uit de HTML-verberging. */
      balk.hidden = false;

      var balkWacht = false;

      function meetBalk() {
        var voorbij = knop.getBoundingClientRect().bottom < 0;

        balk.classList.toggle('is-zichtbaar', voorbij);
        wortel.classList.toggle('kpdp--balk', voorbij);
      }

      function planBalk() {
        if (balkWacht) return;
        balkWacht = true;
        window.requestAnimationFrame(function () {
          balkWacht = false;
          meetBalk();
        });
      }

      window.addEventListener('scroll', planBalk, { passive: true });
      window.addEventListener('resize', planBalk);
      window.addEventListener('load', meetBalk);
      meetBalk();
    }

    /* ── De galerij ────────────────────────────────────────────────── */

    var minirail = wortel.querySelector('.kpdp__thumbs');

    /*
      Alle opnamen staan in het grote vlak; wisselen is een kwestie van tonen
      en verbergen. Een bron omwisselen ging goed voor een foto, maar niet
      voor een filmpje met bediening -- en een filmpje dat doorspeelt terwijl
      het onzichtbaar is, is nog erger.
    */
    function toonBeeld(mini) {
      if (!mini) return;

      var sleutel = mini.getAttribute('data-media');
      var opnamen = wortel.querySelectorAll('[data-kshot]');
      for (var s = 0; s < opnamen.length; s++) {
        var raak = opnamen[s].getAttribute('data-kshot') === sleutel;
        opnamen[s].classList.toggle('is-actief', raak);

        var film = opnamen[s].querySelector('video');
        if (film && !raak && !film.paused) film.pause();
      }

      var alle = wortel.querySelectorAll('[data-kleding-mini]');
      for (var i = 0; i < alle.length; i++) {
        alle[i].classList.toggle('is-active', alle[i] === mini);
        alle[i].setAttribute('aria-current', alle[i] === mini ? 'true' : 'false');
      }
    }

    /*
      De gekozen miniatuur zichtbaar maken in de kolom of de veegrail. Alleen
      nodig als de keuze ergens anders vandaan komt -- bij een klik op de
      miniatuur zelf staat hij al in beeld en zou schuiven storend zijn.
    */
    function haalInBeeld(mini) {
      if (!minirail || !mini) return;
      var m = mini.getBoundingClientRect();
      var r = minirail.getBoundingClientRect();
      if (minirail.scrollHeight > minirail.clientHeight + 1) {
        minirail.scrollTop = minirail.scrollTop + (m.top - r.top);
      } else if (minirail.scrollWidth > minirail.clientWidth + 1) {
        minirail.scrollLeft = minirail.scrollLeft + (m.left - r.left);
      }
    }

    wortel.addEventListener('click', function (e) {
      var mini = e.target.closest('[data-kleding-mini]');
      if (!mini) return;
      toonBeeld(mini);
    });

    adviseur(wortel, varianten, zoekVariant, gekozen);

    toon();
    geopend = true;

    /*
      De rail begint bij de eerste foto. Zonder deze regel blijft een browser
      soms hangen op de plek van een vorig bezoek, of schuift de rail mee
      terwijl de foto's binnenkomen -- en dan opent de pagina op foto zes.
    */
    (function beginBijHetBegin() {
      var rail = wortel.querySelector('.kpdp__thumbs');
      if (!rail) return;
      function terug() {
        if (!uitAdres) rail.scrollLeft = 0;
      }
      terug();
      window.addEventListener('load', terug);
    })();
  }

  /* ================================================================
     De maatadviseur
     ================================================================ */

  /* Onder deze breedte is de adviseur een bodemblad en gaat de pagina op slot. */
  function isBlad() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function adviseur(wortel, varianten, zoekVariant, gekozen) {
    var paneel = wortel.querySelector('[data-adviseur]');
    if (!paneel) return;

    var tekstNode = wortel.querySelector('[data-adviseur-teksten]');
    var T = {};
    try {
      T = JSON.parse(tekstNode.textContent);
    } catch (e) {
      return;
    }

    var lengteVeld = paneel.querySelector('[data-adviseur-lengte]');
    var gewichtVeld = paneel.querySelector('[data-adviseur-gewicht]');
    var foutNode = paneel.querySelector('[data-adviseur-fout]');
    var uitslag = paneel.querySelector('[data-adviseur-uitslag]');
    var maatNode = paneel.querySelector('[data-adviseur-maat]');
    var regelNode = paneel.querySelector('[data-adviseur-regel]');
    var toelichting = paneel.querySelector('[data-adviseur-toelichting]');
    var kiesKnop = paneel.querySelector('[data-adviseur-kies]');
    var ruilNode = paneel.querySelector('[data-adviseur-ruil]');

    var pasvormKnoppen = paneel.querySelectorAll('[data-adviseur-pasvorm]');
    var pasvormIndex = 1;

    /*
      De maattabel: per maat een bereik voor de lengte en een voor het gewicht.
      De eigenaar vult die zelf in, in de theme editor of per product in een
      metaveld.
    */
    var tabel = [];
    var tabelNode = paneel.querySelector('[data-adviseur-tabel]');
    try {
      tabel = JSON.parse(tabelNode.textContent);
    } catch (e) {
      return;
    }
    if (!tabel.length) return;

    /* De maten in volgorde, met per maat of hij te bestellen is. */
    function maten() {
      var uit = [];
      var chips = wortel.querySelectorAll('[data-maat-chip]');
      var kleur = gekozen('kleur');
      for (var i = 0; i < chips.length; i++) {
        var naam = chips[i].getAttribute('data-maat-chip');
        var v = zoekVariant(kleur, naam);
        uit.push({ naam: naam, kan: !!(v && v.beschikbaar) });
      }
      return uit;
    }

    /*
      In welk bereik valt deze waarde? Valt hij er nergens in, dan de dichtstbij
      liggende rand: onder de eerste rij de kleinste maat, boven de laatste de
      grootste. Een gat tussen twee rijen levert de eerstvolgende hogere maat op,
      want te ruim is te herstellen en te krap niet.
    */
    function rijVoor(waarde, van, tot) {
      for (var i = 0; i < tabel.length; i++) {
        var laag = parseFloat(tabel[i][van]);
        var hoog = parseFloat(tabel[i][tot]);
        if (waarde >= laag && waarde <= hoog) return i;
      }
      for (var j = 0; j < tabel.length; j++) {
        if (waarde < parseFloat(tabel[j][van])) return j;
      }
      return tabel.length - 1;
    }

    function advies(lenCm, kg) {
      var lijst = maten();
      var index_omvang = rijVoor(kg, 'gewichtVan', 'gewichtTot');
      var index_lengte = rijVoor(lenCm, 'lengteVan', 'lengteTot');

      /*
        De hoogste van de twee. Een lange, slanke man heeft de lengte van een L
        en de omvang van een S; op alleen gewicht krijgt hij een te kort stuk.
      */
      var index = Math.max(index_omvang, index_lengte);

      if (pasvormIndex === 0) index -= 1;
      if (pasvormIndex === 2) index += 1;
      index = Math.max(0, Math.min(lijst.length - 1, index));

      var ideaal = lijst[index] ? lijst[index].naam : '';
      var uitgeweken = null;

      /*
        Nooit een maat adviseren die niet te bestellen is. Zonder deze stap
        krijgt iedere lange bezoeker een maat geadviseerd die hij niet kan
        kopen, nadat hij twee velden heeft ingevuld.
      */
      if (lijst[index] && !lijst[index].kan) {
        for (var d = 1; d < lijst.length; d++) {
          var omhoog = lijst[index + d];
          var omlaag = lijst[index - d];
          if (omhoog && omhoog.kan) { index = index + d; break; }
          if (omlaag && omlaag.kan) { index = index - d; break; }
        }
        if (lijst[index] && lijst[index].kan) uitgeweken = ideaal;
      }

      var huidig = lijst[index] || { naam: ideaal, kan: false };

      return {
        maat: huidig.naam,
        ideaal: ideaal,
        kan: huidig.kan,
        uitgeweken: uitgeweken,
        grens: Math.abs(index_omvang - index_lengte) >= 2
      };
    }

    function vul(sjabloon, a, lenCm, kg) {
      return (sjabloon || '')
        .replace('{maat}', a.maat)
        .replace('{ideaal}', a.ideaal)
        .replace('{lengte}', lenCm)
        .replace('{gewicht}', kg)
        .replace('{pasvorm}', pasvormKnoppen[pasvormIndex] ? pasvormKnoppen[pasvormIndex].textContent.trim() : '');
    }

    function reken() {
      var len = parseInt(lengteVeld.value, 10);
      var kg = parseInt(gewichtVeld.value, 10);

      lengteVeld.classList.remove('is-fout');
      gewichtVeld.classList.remove('is-fout');

      function fout(node, bericht) {
        node.classList.add('is-fout');
        foutNode.textContent = bericht;
        foutNode.hidden = false;
        uitslag.hidden = true;
        node.focus();
      }

      if (!len || len < 140 || len > 215) return fout(lengteVeld, T.foutLengte);
      if (!kg || kg < 40 || kg > 180) return fout(gewichtVeld, T.foutGewicht);

      foutNode.hidden = true;

      var a = advies(len, kg);

      maatNode.textContent = a.maat;

      var regel = a.kan
        ? (a.uitgeweken ? T.uit : (a.grens ? T.grens : T.gewoon))
        : T.alsOp;
      var uitleg = a.kan
        ? (a.uitgeweken ? T.uitlegUit : (a.grens ? T.uitlegGrens : T.uitlegGewoon))
        : T.uitlegAlsOp;

      regelNode.textContent = vul(regel, a, len, kg);
      toelichting.textContent = vul(uitleg, a, len, kg);

      if (kiesKnop) kiesKnop.hidden = !a.kan;

      /*
        Ruilen beloven voor een stuk dat niet besteld kan worden is onwaar.
      */
      if (ruilNode) ruilNode.hidden = !a.kan;

      kiesKnop.setAttribute('data-maat', a.maat);
      uitslag.hidden = false;
    }

    var waas = wortel.querySelector('[data-adviseur-waas]');
    var opener = wortel.querySelector('[data-adviseur-open]');

    /*
      Open en dicht op één plek. Op mobiel is dit een bodemblad: dan hoort de
      verduistering mee te komen en de pagina eronder op slot, anders scrollt
      de achtergrond door terwijl het blad openstaat.
    */
    function toon(open) {
      paneel.hidden = !open;
      if (waas) waas.hidden = !open;

      if (isBlad()) {
        document.body.style.overflow = open ? 'hidden' : '';
      } else {
        document.body.style.overflow = '';
      }

      if (open && lengteVeld) lengteVeld.focus();
      else if (!open && opener && opener.focus) opener.focus();
    }

    /* Escape sluit, en Tab blijft binnen het blad zolang het openstaat. */
    document.addEventListener('keydown', function (e) {
      if (paneel.hidden) return;

      if (e.key === 'Escape') {
        toon(false);
        return;
      }
      if (e.key !== 'Tab' || !isBlad()) return;

      var items = [].slice.call(paneel.querySelectorAll(
        'button:not([disabled]), input, a[href]'
      )).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;

      var eerste = items[0];
      var laatste = items[items.length - 1];
      if (e.shiftKey && document.activeElement === eerste) {
        e.preventDefault();
        laatste.focus();
      } else if (!e.shiftKey && document.activeElement === laatste) {
        e.preventDefault();
        eerste.focus();
      }
    });

    paneel.addEventListener('click', function (e) {
      var pas = e.target.closest('[data-adviseur-pasvorm]');
      if (pas) {
        pasvormIndex = parseInt(pas.getAttribute('data-adviseur-pasvorm'), 10);
        for (var i = 0; i < pasvormKnoppen.length; i++) {
          pasvormKnoppen[i].classList.toggle('is-active', pasvormKnoppen[i] === pas);
        }
        if (!uitslag.hidden) reken();
        return;
      }

      if (e.target.closest('[data-adviseur-reken]')) {
        reken();
        return;
      }

      if (e.target.closest('[data-adviseur-sluit]')) {
        toon(false);
        return;
      }

      var kies = e.target.closest('[data-adviseur-kies]');
      if (kies) {
        var maat = kies.getAttribute('data-maat');
        var invoer = wortel.querySelector('[data-kleding-optie="maat"][value="' + maat + '"]');
        if (invoer) {
          invoer.checked = true;
          invoer.dispatchEvent(new Event('change', { bubbles: true }));
        }
        toon(false);
      }
    });

    wortel.addEventListener('click', function (e) {
      if (e.target.closest('[data-adviseur-waas]')) {
        toon(false);
        return;
      }
      if (!e.target.closest('[data-adviseur-open]')) return;
      toon(paneel.hidden);
    });
  }

  /*
    De beschrijving: drie zinnen, dan "Lees meer".

    Op zinnen en niet op regels, want zo vroeg de eigenaar het, en een regel
    afknippen laat een halve zin staan. De tekst komt uit de producteditor en
    kan vet, cursief en meerdere alinea's bevatten. Daarom wordt er niets
    verplaatst of opnieuw opgebouwd: na de derde zin gaat alles op verborgen,
    en "Lees meer" zet het weer aan. De opmaak blijft precies zoals hij was.

    Een zin eindigt op . ! of ? gevolgd door witruimte en een hoofdletter,
    cijfer of aanhalingsteken -- of op het eind van een alinea. "o.a. de" en
    "1.5 cm" tellen dus niet als einde.
  */
  var ZINNEN = 3;
  var BLOK = /^(P|LI|H[1-6]|BLOCKQUOTE|DIV|UL|OL)$/;

  function leesMeer(wortel) {
    var vak = wortel.querySelector('[data-kleding-intro]');
    var knop = wortel.querySelector('[data-kleding-leesmeer]');
    if (!vak || !knop || vak.hasAttribute('data-ingekort')) return;
    vak.setAttribute('data-ingekort', '');

    /*
      Alle tekst achter elkaar, met een regeleinde tussen alinea's en op elke
      <br>. Zonder dat plakt "look.<br>Noble" aan elkaar tot "look.Noble" en
      ziet niemand daar een zinseinde in.
    */
    var stukken = [];
    var alles = '';
    var vorigBlok = null;
    var grens = false;
    var loper = document.createTreeWalker(vak, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, null);
    while (loper.nextNode()) {
      var knoop = loper.currentNode;
      if (knoop.nodeType === 1) {
        if (knoop.nodeName === 'BR') grens = true;
        continue;
      }
      if (!knoop.textContent.trim()) continue;

      var blok = knoop.parentNode;
      while (blok !== vak && !BLOK.test(blok.nodeName)) blok = blok.parentNode;
      if (stukken.length && (grens || blok !== vorigBlok)) alles += String.fromCharCode(10);
      vorigBlok = blok;
      grens = false;

      stukken.push({ knoop: knoop, begin: alles.length });
      alles += knoop.textContent;
    }

    var einde = /[.!?…]+["'”’)]*(?=\s+["'“‘(]?[A-ZÀ-Þ0-9]|\s*$)/g;
    var snede = -1;
    var gevonden = 0;
    var m;
    while ((m = einde.exec(alles))) {
      gevonden++;
      if (gevonden === ZINNEN) {
        snede = m.index + m[0].length;
        break;
      }
    }

    /* Drie zinnen of minder, of niets meer na de derde: niets in te korten. */
    if (snede < 0 || !alles.slice(snede).trim()) return;

    var plek = null;
    for (var i = stukken.length - 1; i >= 0; i--) {
      if (stukken[i].begin <= snede) {
        plek = stukken[i];
        break;
      }
    }
    if (!plek) return;

    var snijknoop = plek.knoop;
    var binnen = snede - plek.begin;
    if (binnen < snijknoop.textContent.length) snijknoop.splitText(binnen);

    var verborgen = [];

    function verberg(n) {
      if (n.nodeType === 3) {
        if (!n.textContent.trim()) return;
        var omhulsel = document.createElement('span');
        omhulsel.hidden = true;
        n.parentNode.insertBefore(omhulsel, n);
        omhulsel.appendChild(n);
        verborgen.push(omhulsel);
      } else if (n.nodeType === 1) {
        n.hidden = true;
        verborgen.push(n);
      }
    }

    /* Alles na de snede, op elk niveau van binnen naar buiten. */
    for (var x = snijknoop; x && x !== vak; x = x.parentNode) {
      var zus = x.nextSibling;
      while (zus) {
        var volgende = zus.nextSibling;
        verberg(zus);
        zus = volgende;
      }
    }

    knop.hidden = false;
    knop.setAttribute('aria-expanded', 'false');
    knop.addEventListener('click', function () {
      verborgen.forEach(function (n) { n.hidden = false; });
      knop.setAttribute('aria-expanded', 'true');
      knop.hidden = true;
    });
  }

  function start(bereik) {
    var vlakken = (bereik || document).querySelectorAll('[data-kleding-root]');
    for (var i = 0; i < vlakken.length; i++) {
      leesMeer(vlakken[i]);
      init(vlakken[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
